module.exports = __webpack_public_path__ + "img/67.ad662203.jpg";